export const operationPlan = `
query OperationPlan($slug: String!) {
  operation_plan(slug: $slug) {
    id
    name
    slug
    promo_code {
      code
    }
    started_at
    ended_at
  }
}
`
